module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_24",
      "title": "24"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "toclink_24"
    }
  }, [_vm._v("DICKENS (II)")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre17 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('p', {
    staticClass: "drop-cap pcalibre"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("I take")]), _vm._v(" up my parable for a few words more upon\nthe point at which I broke off last week—the essential\n"), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("greatness")]), _vm._v(" of Dickens. For greatness is a quality in\nsome few men: indefinable perhaps, but yet to be\nrecognised; a certain thing and, by those of us who\nwould traffic with life or literature, not to be overlooked\nor denied save at our soul’s peril, no matter what standard\nof artistry or of refined scholarship we may set up:\na "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("quality")]), _vm._v(" in itself, moreover, and not any addition or\nmultiplication or raising of talent by industry. For an\nillustration of the peril: I was reading, the other day, a\nhistory of French Literature by the late M. Ferdinand\nBrunetière, and, coming to the time of Alexandre\nDumas the elder, I found that the historian, disapproving\nof Dumas, has just left him out! Now that,\nI contend (saving M. Brunetière’s eminence), is to\nwrite oneself down a pedant, outside the catholic mind.\nDumas lived a scandalous life, wrote much execrable\nFrench, and encouraged—even employed—some of his\nfellows to write worse. But the author of "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("The Three\nMusketeers")]), _vm._v(", "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Le Vicomte de Bragelonne")]), _vm._v(", "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("La Reine Margot")]), _vm._v("—Dumas,\n“the seven-and-seventy times to be forgiven,”\nis not to be treated so, by your leave: or only\nso, I repeat, at the critic’s peril. Or let me take an\nEnglishman—John Dryden. I suspect I shall not"), _c('span', {
    attrs: {
      "id": "Page_25",
      "title": "25"
    }
  }), _vm._v("\nmisrepresent or misreport the attitude of many in this\nroom towards Dryden when I say that we find a world\nof slovenly sorry stuff in his dramas, and in his poems\na deal of wit and rhetoric which our later taste—such as\nit is, good or bad, true or false—refuses to pass for\npoetry at all. Now if I merely wanted to prove to you\nthat Dryden at his best could write finely, exquisitely—that\nout of the strong could come forth sweetness—I\ncould content myself with asking you to listen to these\nverses:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("No, no, poor suffering heart, no change endeavour,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Choose to sustain the smart, rather than leave her;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("My ravish’d eyes behold such charms about her,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("I can die with her, but not live without her")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("One tender sigh of her, to see me languish,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Will more than pay the price of my past anguish;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Beware, O cruel fair, how you smile on me,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("’Twas a kind look of yours that has undone me.")])]), _vm._v(" "), _c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Love")]), _vm._v(" has in store for me one happy minute,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And she will end my pain, who did begin it;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Then no day, void of bliss, of pleasure, leaving,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Ages shall slide away without perceiving:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Cupid")]), _vm._v(" shall guard the door, the more to please us,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And keep out "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Time")]), _vm._v(" and "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Death")]), _vm._v(", when they would seize us:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Time")]), _vm._v(" and "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Death")]), _vm._v(" shall depart, and say in flying,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("“Love has found out a way to live—by dying.”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("There, obviously, is a "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("virtuoso")]), _vm._v(" who commands his keyboard.\nBut if I were talking about Dryden to you for\nyour soul’s good, I should rather show you the man\nwith all his imperfections on his head, then turn and\nchallenge you to deny his greatness. Why, you can\nscarcely read a page, even of his prose—say, for choice,"), _c('span', {
    attrs: {
      "id": "Page_26",
      "title": "26"
    }
  }), _vm._v("\nthe opening of his "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Essay of Dramatic Poesy")]), _vm._v("—without\nrecognising the tall fellow of his hands, the giant among\nhis peers,")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry",
    attrs: {
      "xml:lang": "grc"
    }
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse3"
  }, [_vm._v("ψυχἠ ...")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("... μακρὰ βιβᾶσα κατ’ ἀσφοδελὸν λειμῶνα,")])])])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("“pacing with long stride the asphodel meadow” where,\nlet us say, Samuel Johnson walks, and Handel, and\nHugo, nor are they abashed to salute the very greatest—Dante,\nMichelangelo, Shakespeare.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I repeat, Gentlemen, that at all risk of appearing exorbitant\nI should preach this to you for your souls’\ngood. For I do most earnestly want you, before all\nelse, to recognise this "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("quality")]), _vm._v(" of greatness and respond\nto it. In so far as, in your fleeting generation, you give\nme your confidence and honour me (shall I say?) with a\npersonal hope for A or B or C, I would warn you of\nwhat I have experimentally proved to be true of my\ncontemporaries—that the man is most fatally destined\nto be great himself who learns early to enlarge his heart\nto the great masters; that those have steadily sunk who\ncavilled at Caesar with Cassius, or over a cigarette\nchatted admiringly of the rent which envious Casca\nmade: that anyone with an ear learns very surely to\ndistinguish the murmur of the true bee from the morose\nhum of the drone who is bringing no honey, nor ever\nwill, to the hive. In my own time of apprenticeship—say\nin the ’nineties—we were all occupied—after the\nFrench novelists—with style: in seeking the right word,\n"), _c('i', {
    staticClass: "calibre11",
    attrs: {
      "xml:lang": "fr"
    }
  }, [_vm._v("le mot juste")]), _vm._v(", and with “art for art’s sake,” etc. And we\nwere serious enough, mind you. We cut ourselves\nwith knives. To-day, if I may diagnose your more\nyouthful sickness, you are occupied rather with lyricism,"), _c('span', {
    attrs: {
      "id": "Page_27",
      "title": "27"
    }
  }), _vm._v("\ncurious and recondite sensations, appositions of unrelated\nfacts with magenta-coloured adjectives. The\ncraze has spread to the shop-fronts, to curtains, bedspreads,\nas the craze for Byronic collars spread in its\nday: and “Hell is empty!” cried Ferdinand, plunging\noverboard: but you can still find psycho-analysis\nrampant, with any amount of Birth Control, among\nthe geese on Golder’s Green. But if from this desk I\nhave preached incessantly on a text, it is this—that all\nspirit being mutually attractive, as all matter is mutually\nattractive, is an ultimate fact: and that therefore\nwe shall grow the greater and better critics as we surrender\nourselves to the great writers and without\ndetraction, at least until we have, in modesty of mind,\nproved them: since, to apply a word of Emerson’s:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Heartily know—")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("When half-gods go,")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("The gods arrive.")])])])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00011"
    }
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So I broke off, or almost, upon a saying of Tasso’s—you\nmay find it repeated in Ben Jonson’s "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Timber, or\nDiscoveries")]), _vm._v("—that in this world none deserves the name\nof Creator save God himself and the Poet—by “Poet”\nmeaning, of course, the great imaginative artist whether\nworking in restricted verse or in “that other harmony\nof prose.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And you may be thinking—I don’t doubt, a number\nwill be thinking—that in a discourse on Dickens, I am\nputting the claim altogether too high. I can feel your\nminds working, I think—working to some such tune\nas this “Dickens and Virgil, now—Dickens and Dante—Oh,\nheaven alive!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_28",
      "title": "28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("You cannot say that I have shirked it—can you?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Well now, fair and softly! If I had said “Dickens\nand Shakespeare,” it would have given you no such\nshock: and if I had said “Shakespeare and Dante,” or\n“Dickens and Molière,” it would have given you no\nshock at all. I am insisting, you understand, that the\nfirst test of greatness in an imaginative writer is his\npower to create: and I propose to begin with that\nwhich, if there should by any chance happen to be a\nfool in this apparently representative gathering, he\nwill infallibly despise for the easiest thing in the world,\nthe creation of a fool. I beg to reassure him and, so\nfar as I can, restore his self-respect. It is about the\nhardest thing in the world, to create a fool and laugh\nat him. It is a human, nay, even a Godlike function\n(so and not by others shared) to laugh. Listen, before\nwe go further, to these stanzas on divine laughter:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("Nay, ’tis a Godlike function; laugh thy fill!")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Mirth comes to thee unsought:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Mirth sweeps before it like a flood the mill")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Of languaged logic: thought")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Hath not its source so high;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The will")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Must let it by:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("For, though the heavens are still,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("God sits upon His hill")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And sees the shadows fly:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("And if He laughs at fools, why should He not?")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("“Yet hath the fool a laugh”—Yea, of a sort;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("God careth for the fools;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The chemic tools")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Of laughter He hath given them, and some toys")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Of sense, as ’twere a small retort")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Wherein they may collect the joys")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "Page_29",
      "title": "29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Of natural giggling, as becomes their state:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("The fool is not inhuman, making sport")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("For such as would not gladly be without")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("That old familiar noise:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Since, though he laugh not, he can cachinnate—")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("This also is of God, we may not doubt.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("Shakespeare, as we know, delighted in a fool, and\nrevelled in creating one. (I need hardly say that I am\nnot talking of the professionals, such as Touchstone or\nthe Fool in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Lear")]), _vm._v(", who are astute critics rather, ridiculing\nthe folly of their betters by reflexion by some odd facet\nof common sense, administering hellebore to minds\ndiseased and so in their function often reminding us\nof the Chorus in Greek tragedy.) I mean, of course, the\nfool in his "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("quiddity")]), _vm._v(", such as Dogberry, or Mr. Justice\nShallow, or Cousin Abraham Slender. Hearken to\nDogberry:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Dog.")]), _vm._v(" Come hither, neighbour Seacole. God hath blessed\nyou with a good name: to be a well-favoured man is the\ngift of fortune; but to write and read comes by nature.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Sec. Watch.")]), _vm._v(" Both which, master "), _c('span', {
    staticClass: "locked"
  }, [_vm._v("Constable—")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Dog.")]), _vm._v(" You have: I knew it would be your answer.\nWell, for your favour, sir, why, give God thanks, and\nmake no boast of it; and for your writing and reading,\nlet that appear when there is no need of such vanity.")])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("Why, it might be an extract from the Geddes Report—or\nso much of it as deals with Education!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("And now to Slender, bidden in by sweet Anne Page\nto her father’s dinner-table:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" Will it please your worship to come in, sir?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" No—I thank you, forsooth—heartily. I am\nvery well.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_30",
      "title": "30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" The dinner attends you, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" I am not a-hungry, I thank you, forsooth....")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" I may not go in without your worship; they\nwill not sit till you come.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" I’faith, I’ll eat nothing: I thank you as much\nas though I did.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" I pray you, sir, walk in.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" I had rather walk here—I thank you. I bruised\nmy shin th’ other day with playing at sword and dagger\nwith a master of fence—three veneys for a dish of stewed\nprunes—and, I with my ward defending my head, he shot\nmy shin, and by my troth, I cannot abide the smell of hot\nmeat since.... Why do your dogs bark so? Be there\nbears in town?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" I think there are, sir. I heard them talked of.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" I love the sport well, but I shall as soon quarrel\nat it as any man in England.... "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("You")]), _vm._v(" are afraid, if\nyou see a bear loose, are you not?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Anne.")]), _vm._v(" Ay, indeed, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Slender.")]), _vm._v(" That’s meat and drink to me, now: I have seen\nSackerson loose—twenty times, and have taken him by the\nchain.... But women, indeed, cannot abide ’em—they\n"), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("are")]), _vm._v(" very ill-favoured rough things.")])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("“Othello,” as Hartley Coleridge noted, “could not\nbrag more amorously”: and, as I wrote the other day\nin an introduction to "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("The Merry Wives")]), _vm._v(", when Anne\nfinally persuades him to walk before her into the house,\nmy fellow-editor and I had written (but afterwards in\ncowardice erased) the stage-direction, "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("He goes in: she\nfollows with her apron spread, as if driving a goose.")]), _vm._v(" Yes,\ntruly, Slender is a goose to say grace over and to be\ncarved “as a dish fit for the gods.” “A very potent\npiece of imbecility,” writes Hazlitt, and adds, “Shakespeare\nis the only writer who was as great in describing\nweakness as strength.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_31",
      "title": "31"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Well, Jane Austen and Charles Dickens came after,\nto confirm Hazlitt’s observation. No one seeks in\nJane Austen for examples of strength: and you will\nfind none in Dickens to compare with Othello or\nCleopatra or (say) with Mr. Hardy’s Mayor of Casterbridge.\nBut, like Charles Lamb, Jane Austen and\nDickens both “loved a fool”: Jane Austen delicately,\nDickens riotously: witness the one’s Miss Bates, the\nother’s Mr. Toots. But observe, pray: the fools they\ndelight in are always—like Slender, like Miss Bates,\nlike Mr. Toots—simple fools, sincere fools, good at\nheart, good to live with, and in their way, the salt of\nthe earth. Miss Bates herself bears unconscious\nwitness to this in one of her wisest foolishest remarks—“It\nis such a happiness when good people get together—and\nthey always do.” (Consoling thought for you and\nme at this very moment.) With the fool who is also\na humbug, a self-deceiver, Dickens could find no\npatience in his heart; and this impatience of his you\nmay test again and again, always to find it—if I may\nsay so with reverence—as elementary as our Lord’s.\nI am not speaking of conscious, malignant hypocrites—your\nStiggins’s, Pecksniffs, Chadbands—on whom\nDickens waged war, his life through; but of the self-deceiving\nfool whom we will agree with him in calling\nan “ass”—Uncle Pumblechook, for instance, in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Great\nExpectations")]), _vm._v(", Mr. Sapsea in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Edwin Drood")]), _vm._v("; on whom,\nor on whose kind, as he grew older, he seems (most of\nall in his last book, whenever handling Mr. Sapsea) to\nlose his artistic self-control, to savage them. But of\nkind fools, lovable fools, good fools, God’s fools,\nDickens’ heaven will open any moment at call and\nrain you down half-a-dozen, all human, each distinct.\nYou may count half-a-dozen in his most undeservedly"), _c('span', {
    attrs: {
      "id": "Page_32",
      "title": "32"
    }
  }), _vm._v("\nmisprised book, "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Little Dorrit")]), _vm._v(", omitting Mr. F.’s Aunt:\nwho is an eccentric, rather, though an unforgettable one\nand has left her unforgettable mark on the world in less\nthan 200 words. She stands apart: for the others,\napart from foolishness, share but one gift in common,\na consanguinity (as it were) in flow of language or\ndetermination of words to the mouth. Shall we select\nthe vulgar, breathless, good-natured widow, Flora\nFinching, ever recalling the past (without so much\npause as a comma’s) to her disillusioned first "), _c('span', {
    staticClass: "locked"
  }, [_vm._v("lover?—")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In times for ever fled Arthur pray excuse me Doyce and\nClennam (the name of his firm) infinitely more correct and\nthough unquestionably distant still ’tis distance lends enchantment\nto the view, at least I don’t mean that and if I\ndid I suppose it would depend considerably on the nature\nof the view, but I’m running on again and you put it all\nout of my head.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("She glanced at him tenderly and resumed:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("In times for ever fled I was going to say it would have\nsounded strange indeed for Arthur Clennam—Doyce and\nClennam naturally quite different—to make apologies for\ncoming here at any time, but that is past and what is past\ncan never be recalled except in his own case as poor Mr. F.\nsaid when in spirits Cucumber and therefore never ate it....\nPapa is sitting prosingly, breaking his new laid\negg over the City article, exactly like the Woodpecker\nTapping, and need never know that you are here....")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("The withered chaplet is then perished the column is\ncrumbled and the pyramid is standing upside down upon\nits what’s-his-name call it not giddiness call it not weakness\ncall it not folly I must now retire into privacy and\nlooking upon the ashes of departed joys no more but taking\nthe further liberty of paying for the pastry which\nhas formed the humble pretext for our interview, will for\never say Adieu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_33",
      "title": "33"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mr. F’s Aunt who had eaten her pie with great solemnity ...\nand who had been elaborating some grievous\nscheme of injury in her mind, took the present opportunity\nof addressing the following sibyllic apostrophe to\nthe relict of her late nephew: “Bring him for’ard, and I’ll\nchuck him out o’ winder!”")])]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00012"
    }
  }, [_vm._v("III")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Mr. Chesterton, selecting another fool from the\ngallery—Young Mr. Guppy, of "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Bleak House")]), _vm._v("—observes\nvery wisely, that we may disapprove of Mr. Guppy, but\nwe recognise him as a creation flung down like a miracle\nout of an upper sphere: we can pull him to pieces, but\nwe could not have put him together. And this (says\nhe) is the pessimists’ disadvantage in criticising any\ncreation. Even in their attacks on the Universe they\nare always under this depressing disadvantage.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“A man looking at a hippopotamus may sometimes\nbe tempted to regard the hippopotamus as an enormous\nmistake: but he is also bound to confess that a fortunate\ninferiority prevents him personally from making such\na mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Well, that is, of course, our difficulty in criticising all\ncreative genius. We tell ourselves how we could have\nsuggested to Shakespeare—or to Dickens—his doing\nthis or that better than he did; but the mischief is, "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("we")]), _vm._v("\ncould not have done it at all. And in this matter of\nMr. Guppy, Mr. Chesterton continues: “Not one of us\ncould have invented Mr. Guppy. But even if we could\nhave stolen Mr. Guppy from Dickens, we have still to\nconfront the fact that Dickens would have been able to\ninvent another quite inconceivable character to take his\nplace.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_34",
      "title": "34"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00013"
    }
  }, [_vm._v("IV")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Here we get to it. I have instanced his fools only,\nand but a select two or three of these for a test: but you\nmay take, if you will, shrewd men, miserly men, ruffians,\ndoctors, proctors, prisoners, schoolmasters, coachmen,\nlicensed victuallers, teetotallers, thieves, monthly\nnurses—whatever the choice be, Dickens will shake\nthem out of his sleeve to populate a world for us. For,\nlike Balzac, he has a world of his own and can at call\ndispense to us of its abundance.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("What sort of a world is it out of which Dickens so\nenriches ours?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Well, to begin with, it is a crowded world, a world\nthat in his imagination positively teems with folk\ngoing, coming, hurrying: of innumerable streets where\nyou may knock in (and welcome) at any chance door\nto find the house in accumulated misery, poverty, woe,\nor else in a disorder of sausages and squalling children,\nwith a henpecked husband at one end of the table, a\nbowl of punch in the middle, and at the other end a\nmortuary woman whose business in life is to make a\nburden of life to all who live near her and would have\nher cheerful. (There was never such a man as Dickens\nfor depicting the blight induced by one ill-tempered\nperson—usually a woman—upon a convivial gathering.)\nThe henpecked husband dispensing the punch is, likely\nas not, a city clerk contriving a double debt to pay, a\nslave during office hours, bound to a usurious master: a\nsort of fairy—a Puck, a Mr. Wemmick, as soon as he\nsheds his office-coat and makes for somewhere in the\nuncertain gaslight of the suburbs, “following darkness\nlike a dream.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Yes, this world is of the streets; in which Dickens"), _c('span', {
    attrs: {
      "id": "Page_35",
      "title": "35"
    }
  }), _vm._v("\nwas bred and from which he drew the miseries and\nconsolations of his boyhood. A world “full of folk,”\nbut not, like Piers Plowman’s, a “"), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("field")]), _vm._v(" full of folk.”\nHis understanding of England is in many ways as deep\nas Shakespeare’s; but it is all, or almost all, of the urban\nEngland which in his day had already begun to kill the\nrural. I ask you to consider any average drawing of\nPhiz’s; the number of figures crowded into a little room,\nthe many absurd things all happening at once, and you\nwill understand why Phiz was Dickens’ favourite illustrator.\nA crowded world: an urban world, largely a\nmiddle-class and lower-class London world—what else\ncould we expect as outcome of a boyhood spent in\npoverty and in London? Of London his knowledge is\nindeed, like Sam Weller’s, “extensive and peculiar”:\nwith a background or distance of the lower Thames,\nblack wharves peopled by waterside loafers or sinister\nfishers in tides they watch for horrible traffic; rotting\npiles such as caught and held the corpse of Quilp.\nSome sentiment, indeed, up Twickenham-way: a\nhandful of flowers, taken from the breast and dropped\nat the river’s brink, to be floated down, pale and unreal,\nin the moonlight; “and thus do greater things\nthat once were in our breasts and near our hearts, flow\nfrom us to the eternal seas.” But before they reach\nthe eternal seas they must pass Westminster Bridge\nwhence an inspired dalesman saw the City wearing\nthe beauty of dawn as a garment.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Ships, towers, domes, theatres and temples ...\nand Waterloo Bridge, Hood’s dark arch of tragedy;\nand London Bridge, hymned of old by Dunbar. Dickens’\nbridge is the old Iron one by Hungerford, and under\nit the Thames runs down to ghastly flats, convict-haunted,\nbelow Woolwich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_36",
      "title": "36"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Shakespeare knew his London, his Eastcheap, its\ntaverns. But when you think of Shakespeare you\nthink (I will challenge you) rather of rural England, of\nAvon, of Arden, of native wood-notes wild. I hold it\ndoubtful that Falstaff on his death-bed babbled o’\ngreen fields: but I will take oath that when he got down\nto Gloucestershire he smelt the air like a colt or a boy\nout of school. And Justice Shallow is there—always\nthere!")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Silence.")]), _vm._v(" This Sir John, cousin, that comes hither anon\nabout soldiers?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Shallow.")]), _vm._v(" The same Sir John, the very same. I saw him\nbreak Skogan’s head at the court-gate, when a’ was a\ncrack not thus high: and the very same day did I fight\nwith one Sampson Stockfish, a fruiterer, behind Gray’s\nInn. Jesu, Jesu, the mad days I have spent! and to see\nhow many of my old acquaintance are dead!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Silence.")]), _vm._v(" We shall all follow, cousin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Shallow.")]), _vm._v(" Certain, ’tis certain; very sure, very sure:\ndeath, as the Psalmist saith, is certain to all; all shall die.\nHow a good yoke of bullocks at Stamford fair?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Silence.")]), _vm._v(" By my troth, I was not there.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Shallow.")]), _vm._v(" Death is certain. Is old Double of your town\nliving yet?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Silence.")]), _vm._v(" Dead, sir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Shallow.")]), _vm._v(" Jesu, Jesu, dead! a’ drew a good bow: and dead!\na’ shot a fine shoot: John a Gaunt loved him well, and\nbetted much money on his head. Dead!—a’ would have\nclapped i’ the clout at twelve score; and carried you a\nforehand shaft a fourteen and fourteen and a half, that it\nwould have done a man’s heart good to see. How a score\nof ewes now?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Silence.")]), _vm._v(" Thereafter as they be: a score of good ewes may\nbe worth ten pounds.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Shallow.")]), _vm._v(" And is old Double dead?")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_37",
      "title": "37"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("You get little or none of that solemn, sweet rusticity in\nDickens: nor of the rush of England in spring with\nslow country-folk watching it:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("The fields breathe sweet, the daisies kiss our feet,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Young lovers meet, old wives a-sunning sit;")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("In every street these tunes our ears do greet—")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Cuckoo, jug-jug, pu-we, to-witta-woo!")])]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("Spring, the sweet Spring!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("You will remember that "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Pickwick")]), _vm._v(", in its first conception,\nwas to deal with the adventures and misadventures\nof a Sporting Club after the fashion of the "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Handley\nCross")]), _vm._v(" series by Surtees. Now Surtees—not a great\nwriter but to this day (at any rate to me) a most amusing\none—was, although like Dickens condemned to\nLondon and the law, a north-country sportsman, and\ncould ride and, it is reported, “without riding for effect\nusually saw a deal of what the hounds were doing.”\nThe Pickwickian sportsmen had to decline "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("that")]), _vm._v(" competition\nvery soon.")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00014"
    }
  }, [_vm._v("V")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But they, and a host of Dickens’ characters, are very\ndevils for post-chaises.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“If I had no duties, and no deference to futurity,\nI would spend my life in driving briskly in a post-chaise\nwith a pretty woman,” said Dr. Johnson.\n“There are milestones on the Dover Road,” and we\nspin past them. You will remember that Dickens in\nhis apprenticeship spent a brief but amazingly strenuous\nwhile as reporter for the "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Morning Chronicle")]), _vm._v(", scouring the"), _c('span', {
    attrs: {
      "id": "Page_38",
      "title": "38"
    }
  }), _vm._v("\ncountry after political meetings by road-vehicles in all\nweathers. As he told his audience, twenty years later,\nat the annual dinner of the Newspaper Press Fund:")]), _vm._v(" "), _c('div', {
    staticClass: "blockquot"
  }, [_c('p', {
    staticClass: "calibre3"
  }, [_vm._v("I have often transcribed for the printer, from my shorthand\nnotes, important public speeches in which the strictest\naccuracy was required, and a mistake in which would\nhave been, to a young man, severely compromising, writing\non the palm of my hand, by the light of a dark lantern,\nin a post-chaise and four galloping through a wild country,\nand through the dead of night, at the then surprising rate of\nfifteen miles an hour.... Returning home from exciting\npolitical meetings in the country (and it might be from\nExeter west, or Manchester north) to the waiting press in\nLondon, I do verily believe I have been upset in almost\nevery description of vehicle known in this country. I\nhave been, in my time, belated in miry by-roads, forty or\nfifty miles from London, in a wheel-less carriage, with\nexhausted horses and drunken post-boys, and have got\nback in time for publication....")])]), _vm._v(" "), _c('p', {
    staticClass: "in"
  }, [_vm._v("So, you see, this world Dickens imagined was more\nthan crowded; it was a hurrying, a breathless one.\nThis sense of speed in travel, of the wind in one’s face;\nof weight and impetus in darkness, with coach lamps\nflaring through the steam from your good horses’ hindquarters,\nruns as an inspiration through much of the\nliterature of the early nineteenth century. De Quincey\nhas hymned it magnificently in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("The English Mail Coach")]), _vm._v(",\nand you may enjoy a capital drive of the sort in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Tom\nBrown’s School Days")]), _vm._v(": and always the rush of air whets\nyour appetite for the hot rum-and-water at the stage\nhostelry or the breakfast of kidney-pie. Dickens saw\nthe invasion of the railway train, and lived to be disastrously"), _c('span', {
    attrs: {
      "id": "Page_39",
      "title": "39"
    }
  }), _vm._v("\nmixed up in a railway collision. But railway-train\ntravelling at sixty miles an hour or over, has a\nstatic convenience. For the pleasures of inconvenient\ntravel, without a time-table, I have recourse to a sailing-boat:\nbut I can well understand my fellow-creature\nwho prefers a car or a motor-bicycle to the motion of\nfour horses at a stretch gallop. With the wind of God\nin his face he gets there (wherever it is) before the dew\nis dry, does his business, swallows his bun and Bovril\nand is home again with an evening paper for the cosy\ngas-cooked meal, ere yet Eve has drawn over his little\nplace in the country her gradual dusky veil.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("Rapid travel, as Dickens well knew it and how to\ndescribe it—with crime straining from what it fears—is\none of his most potent resources. Read the flight of\nCarker in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Dombey and Son")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00015"
    }
  }, [_vm._v("VI")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("His is a crowded world then, tumultuous and full\nof fierce hurry: but a world (let us grant it) strangely\nempty of questioning ideas, subtle nuisances that haunt\nmany thoughtful men’s souls, through this pass of\nexistence “still clutching the inviolable shade.” He\nwrote far better novels than "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("John Inglesant")]), _vm._v(", novels far,\nfar, better than "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Robert Ellesmere")]), _vm._v("; but you cannot conceive\nhim as interested in the matter of these books—which\nyet is serious matter. Still less, or at least as\nlittle, can you imagine him pursuing the track of so\nperplexed a spirit as Prince André in Tolstoy’s "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("War and\nPeace")]), _vm._v(". Churches annoyed him. He will, of a christening\nor a marriage service (let be a funeral), make the\nmouldiest ceremony in the world. We offer the baby\nup; we give the blushing bride away; but in the very"), _c('span', {
    attrs: {
      "id": "Page_40",
      "title": "40"
    }
  }), _vm._v("\nact we catch ourselves longing for that subsequent chat\nwith the pew-opener which he seldom denies us for\nreward. Dickens, in short, had little use for religious\nforms or religious mysteries: for he carried his own\nreligion about with him and it was the religion of James—so\nannoying alike to the mystic and the formalist—“to\nvisit the fatherless and widows in their affliction,\nand to keep himself unspotted from the world.” This\nagain belongs to his “universality.” Is it not the\nreligion of most good fellows not vocal? It is observable\nhow many of his heroes and heroines—his child\nheroes and heroines especially—pass through his\nthronged streets and keep themselves unspotted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But, if careless of mysteries, Dickens had a hawk’s\neye for truth of morals. You never find him mocking a\ngood or condoning an evil thing: here his judgment\nand its resultant passion of love or of hate, I dare to\nsay, never went wrong. Sinners—real sinners—in\nDickens have the very "), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("inferno")]), _vm._v(" of a time: the very forces\nof Nature—“fire and hail, snow and vapours, wind and\nstorm, fulfilling God’s word”—hunt the murderer to\nthe pit that yawns; till he perishes, and the sky is clear\nagain over holy and humble men of heart. Again,\nwitness, here, the elemental flight of Jonas Chuzzlewit.\nCarlyle never said an unjuster thing (and that is saying\na deal) than when he accused Dickens’ theory of life as\nentirely wrong. “He thought men ought to be\nbuttered up ... and all sorts of fellows have turkey\nfor their Christmas dinner.” It is false. Dickens had\na keener eye for sin than Carlyle ever had; and a\nrelentless eye: “a military eye,” said Henry James of it,\nrecalling his first introduction to the great man—“a\n"), _c('em', {
    staticClass: "calibre11"
  }, [_vm._v("merciless")]), _vm._v(" military eye.” “A field-punishment eye,” "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("I")]), _vm._v("\nsay!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_c('span', {
    attrs: {
      "id": "Page_41",
      "title": "41"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "calibre18 sigil_not_in_toc",
    attrs: {
      "id": "pgepubid00016"
    }
  }, [_vm._v("VII")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("But this world of Dickens, you may object, was an\nunreal world, a phantasmagoric world. Well, I hope to\ndiscuss that—or rather the inference from it—in my\nnext lecture, which shall deal, in Aristotelian order,\nwith his plots first and his characters next. But, for\nthe moment, if you will, Yes: his world was like\nnothing on earth: yes, it is liker to Turner’s sunset to\nwhich the critic objected “he never saw a sunset like\nthat,” and was answered, “Ah, but don’t you wish\nyou could?” Yes, for Dickens made his world—as\nthe proud parent said of his son’s fiddle—“he made it,\nsir, entirely out of his own head!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("“Night is generally my time for walking” (thus\nbegins Master Humphrey, in "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("The Old Curiosity Shop")]), _vm._v(")\n“although I am an old man.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre3"
  }, [_vm._v("So in that crowded phantasmagoric city of London,\nwhich is in his mind, Dickens walks by night—not like\nAsmodeus, lifting the roofs and peering into scandals:\nbut like the good Caliph of his favourite "), _c('i', {
    staticClass: "calibre11"
  }, [_vm._v("Arabian Nights")]), _vm._v(",\nintent to learn the life of the poor and oppressed, and\nas a monarch to see justice done them: a man patterning\nhis work on the great lines of Fulke Greville, sometime\nof Jesus College, in this town; with which let me conclude\nto-day:")]), _vm._v(" "), _c('div', {
    staticClass: "poetry-container"
  }, [_c('div', {
    staticClass: "poetry"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('div', {
    staticClass: "verse"
  }, [_vm._v("The chief use, then, in man, of that he knows,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Is his painstaking for the good of all:")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Not fleshly weeping for our own-made woes,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Not laughing from a melancholy gall,")]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_vm._v("Not hating from a soul that overflows")]), _vm._v(" "), _c('div', {
    staticClass: "verse2"
  }, [_vm._v("With bitterness, breath’d out from inward thrall:")]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("But sweetly rather to ease, loose, or bind,")]), _vm._v(" "), _c('div', {
    staticClass: "verse4"
  }, [_vm._v("As need requires, this frail, fall’n humankind.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0